import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05e1e9e6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=05e1e9e6&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=05e1e9e6&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e1e9e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e1e9e6')) {
      api.createRecord('05e1e9e6', component.options)
    } else {
      api.reload('05e1e9e6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=05e1e9e6&scoped=true", function () {
      api.rerender('05e1e9e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/reject/index.vue"
export default component.exports